/** One item in the detail gallery: an image URL or a portal video attachment. */
export type MediaSlide = { src: string; video: boolean; name?: string };

/**
 * Images first (the main product/service shot stays the hero), then the
 * `video_ids` attachments from Odoo. Their portal URLs carry no file
 * extension, so `mimetype` is the only way to tell a video apart.
 */
export function buildMediaSlides(
  images: unknown,
  videoIds: unknown
): MediaSlide[] {
  const imageSlides = (Array.isArray(images) ? images : [])
    .filter((src): src is string => typeof src === "string" && src !== "")
    .map((src) => ({ src, video: false }));

  const videoSlides = (Array.isArray(videoIds) ? videoIds : [])
    .filter(
      (item: any) =>
        typeof item?.url === "string" &&
        item.url !== "" &&
        String(item?.mimetype ?? "").startsWith("video/")
    )
    .map((item: any) => ({
      src: item.url as string,
      video: true,
      name: typeof item?.name === "string" ? item.name : undefined,
    }));

  return [...imageSlides, ...videoSlides];
}
